export enum WhoPaysOption {
    CLIENT = "client",
    ORGANIZATION = "organization",
    OTHER_FIRM = "otherFirm",
}

export const whoPaysLabels = {
    [WhoPaysOption.CLIENT]: "Client",
    [WhoPaysOption.ORGANIZATION]: "My firm", // This will be replaced with actual org name
    [WhoPaysOption.OTHER_FIRM]: "Other firm",
} as const satisfies Record<WhoPaysOption, string>;
